export const alertConstants = {
    HIDE: 'HIDE_SUCESS',
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    WARNING: 'ALERT_WARNING',
    INFO: 'ALERT_INFO' // Jeino
};
